import PropTypes from 'prop-types';
import { useLCAPlot, useNodeById } from '@/stores/analysisStore';
import { getLCAYaxisLabel, parseLCABreakdownByScope, parsePathwayEmissionsBreakdownData } from '@/utils/analysisUtils';
import CostBreakdownChart from '@/components/charts/CostBreakdownChart';
import AnalysisContainer from '@/components/core/AnalysisContainer';
import AnalysisBox from '@/components/core/AnalysisBox';

const ScopeBreakdown = ({ scope, plot, node, digits }) => {
  const breakdownResults = parseLCABreakdownByScope(plot.results, scope);

  return (
    <CostBreakdownChart
      breakdownResults={breakdownResults}
      yAxisLabel={`Scope ${scope} Breakdown - ${node.label}\n[${getLCAYaxisLabel(plot)}]`}
      digits={digits}
      unit={getLCAYaxisLabel(plot)}
      itemLabel={scope === 1 ? 'Internal Process' : 'Feedstock Item'}
    />
  );
};

ScopeBreakdown.propTypes = {
  scope: PropTypes.number.isRequired,
  plot: PropTypes.shape({
    results: PropTypes.array,
  }).isRequired,
  node: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
  digits: PropTypes.number.isRequired,
};

const LCABreakdownPlot = () => {
  const plot = useLCAPlot();
  const { nodeId, scope1Breakdown, scope3Breakdown, levelize, pathway_emissions_breakdown } = plot;
  const node = useNodeById(nodeId);
  const digits = levelize === 'true' ? 2 : 0;

  if (!scope1Breakdown && !scope3Breakdown) {
    return null;
  }

  return (
    <AnalysisContainer title="Emissions Breakdown">
      <AnalysisBox>
        <div className="flex flex-col gap-8">
          {scope1Breakdown && <ScopeBreakdown scope={1} plot={plot} node={node} digits={digits} />}
          {scope3Breakdown && <ScopeBreakdown scope={3} plot={plot} node={node} digits={digits} />}
          {scope3Breakdown && pathway_emissions_breakdown && (
            <CostBreakdownChart
              breakdownResults={parsePathwayEmissionsBreakdownData(pathway_emissions_breakdown)}
              yAxisLabel={`Pathway Emissions Breakdown - ${node.label}\n[${getLCAYaxisLabel(plot)}]`}
              digits={digits}
              unit={getLCAYaxisLabel(plot)}
              itemLabel="Module"
            />
          )}
        </div>
      </AnalysisBox>
    </AnalysisContainer>
  );
};

export default LCABreakdownPlot;
